module.exports = __webpack_public_path__ + "static/media/play-app-store.19354164.jpg";